//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import jsPDF from 'jspdf';
import html2canvas from 'html2canvas'
let token = localStorage.getItem("token-admin")

export default {
  name: 'LembarNotaDinas',
  props: {
    id: String
  },
  data:function(){
    return{
      memo: {},
      memofinal:{},
      showInput: false
    }
  },
  mounted(){
    this.$http.get('/nodin_byid/'+this.id, {
      headers: { Authorization: "Bearer " + token}
    })
    .then (result => {
      this.memo = result.data
    })
  },
  methods:{
    sendNodin(){
      this.memofinal.id = this.memo.id
      this.memofinal.status = 2
      this.memofinal.sent = 'Y'
      this.memofinal.updatedBy = this.$store.state.currentAdmin.username
      this.$http.put("/update_memo/" + this.memofinal.id, this.memofinal, {
        headers: { Authorization: "Bearer " + token}
      } )
      .then((result) => {
        this.$http.get('/nodin_byid/'+this.id, {
          headers: { Authorization: "Bearer " + token}
        })
        .then (result => {
          this.memo = result.data
          
          this.$q.notify({
            icon: "done",
            color: "positive",
            message: "Nota dinas terkirim",
          });

        })
      });
    },
    print () {
      var filename = 'Nota Dinas ' + this.memo.numberMemo + '.pdf'// this.coa.date_out.substr(0,10) + "_" + this.coa.nama_sampel + "_" + this.coa.batch +".pdf"
      
      const doc = new jsPDF("p", "mm", "a4");
      /** WITH CSS */
      var canvasElement = document.createElement('canvas');
      html2canvas(this.$refs.content, {  }).then(function (canvas) {
        const img = canvas.toDataURL("image/png");
        doc.addImage(img,'JPEG',0, 0, 210, 297, 'copy of', 'MEDIUM');
        doc.save(filename);
      });
    }
  }

}
